// extracted by mini-css-extract-plugin
export default {"content":"AssistantMessageMarkdown_content__ZVhFW","wrapper":"AssistantMessageMarkdown_wrapper__4ueXk"};